import { useRef } from 'react';
import { inputIndex, type inputType } from '../types';
import { DebtInput } from '../debt-input';
import {
  Box,
  Typography,
  Button,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const MAX_DEBT = 99999;

type DebtDialogProps = {
  isOpen: boolean;
  debt: inputType;
  unavailableInputs: string[];
  onChange?: (
    idx: string,
    inputIdx: inputIndex,
    value: string | number
  ) => void;
  onConfirm: (index: string) => void;
  onCancel: () => void;
};

export const DebtDialog = ({
  isOpen = false,
  debt,
  unavailableInputs = [],
  onChange,
  onConfirm,
  onCancel,
}: DebtDialogProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  if (!debt?.index) return null;

  const evaluateDisableConfirmation = () => {
    return (
      debt[inputIndex.AMOUNT] === null ||
      debt[inputIndex.AMOUNT] > MAX_DEBT ||
      debt[inputIndex.AMOUNT] <= 0 ||
      !debt[inputIndex.INSTITUTION] ||
      !debt[inputIndex.DEBT_TYPE]
    );
  };

  const handleDialogClick = (event: any) => {
    if (event.target.localName === 'body') {
      return;
    }
    if (wrapperRef.current && wrapperRef.current.contains(event.target)) {
      return;
    }
    onCancel();
  };

  return (
    <Dialog
      open={isOpen}
      scroll="body"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            margin: '0',
            width: '90%',
            maxWidth: '90%',
            '& .MuiDialogContent-root': { paddingTop: '1rem' },
          },
        },
      }}
    >
      <ClickAwayListener onClickAway={handleDialogClick}>
        <Box ref={wrapperRef}>
          <DialogTitle textAlign="center" sx={{ paddingBottom: '0' }}>
            <Typography variant="accent">add debt</Typography>
          </DialogTitle>
          <DialogContent>
            <DebtInput
              debt={debt}
              onChange={onChange}
              unavailableInputs={unavailableInputs}
              direction="column"
            />
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              marginTop={4}
            >
              <Button
                variant="outlined"
                sx={{
                  width: '136px',
                  height: '44px',
                }}
                onClick={() => {
                  onCancel();
                }}
              >
                <Typography sx={{ textTransform: 'uppercase' }}>
                  cancel
                </Typography>
              </Button>
              <Button
                sx={{
                  width: '136px',
                  height: '44px',
                }}
                onClick={() => {
                  onConfirm(debt.index);
                }}
                disabled={evaluateDisableConfirmation()}
              >
                <Typography sx={{ textTransform: 'uppercase' }}>
                  confirm
                </Typography>
              </Button>
            </Box>
          </DialogContent>
        </Box>
      </ClickAwayListener>
    </Dialog>
  );
};
